<template>
  <div>
    <table-header-setting
      class="m-l-10 m-b-10"
      style="text-align: right; margin-top: -50px"
      :table-config="listOption"
      :purchase-type="10"
      @refresh="getHeader"
    />
    <el-table
      ref="table"
      :key="tableKey"
      border
      :data="tableData"
      max-height="400"
      :header-cell-style="{ background: '#f5f5f5' }"
      size="medium"
      :span-method="objectSpanMethod"
      @header-dragend="headerDragend"
    >
      <el-table-column
        align="center"
        label="序号"
        prop="index"
        width="50"
        fixed
      >
        <template slot-scope="{ row, $index }">
          <span>{{ indexNum(row, $index) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        label="品目名称"
        prop="materielName"
        width="100"
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielCode')"
        show-overflow-tooltip
        align="center"
        label="品目编码"
        prop="materielCode"
        width="100"
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielNum')"
        show-overflow-tooltip
        align="center"
        label="数量"
        prop="materielNum"
        width="80"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.materielNum ? strToThousands(row.materielNum) : 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielModel')"
        show-overflow-tooltip
        align="center"
        label="参数型号"
        prop="materielModel"
        width="100"
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielBrand')"
        show-overflow-tooltip
        align="center"
        label="品牌/制造商"
        prop="materielBrand"
        width="120"
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielBrand || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        label="授标量"
        prop="candidateNum"
        width="80"
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.candidateNum ? strToThousands(row.candidateNum) : 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('deliveryAddress')"
        align="center"
        label="交货地点"
        show-overflow-tooltip
        prop="deliveryAddress"
        width="90"
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryAddress || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('deliveryDay')"
        show-overflow-tooltip
        align="center"
        label="交货时间(天)"
        width="140"
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryDay || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('budgetUnitPrice')"
        show-overflow-tooltip
        align="center"
        :label="
          `${isWuling && !requireTax ? '预算不含税单价' : '预算单价'}(${
            isDollar ? '美元' : '元'
          })`
        "
        :width="isWuling ? 160 : 140"
      >
        <template slot-scope="{ row }">
          <div>
            {{
              row.budgetUnitPrice ? strToThousands(row.budgetUnitPrice) : '-'
            }}
          </div>
          <div v-if="row.targetPrice">
            目标单价:
            {{ row.targetPrice ? strToThousands(row.targetPrice) : '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('totalPrice')"
        show-overflow-tooltip
        align="center"
        :label="
          `${isWuling && !requireTax ? '预算不含税总价' : '预算总价'}(${
            isDollar ? '美元' : '元'
          })`
        "
        :width="isWuling ? 160 : 140"
      >
        <template slot-scope="{ row }">
          <div>
            {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
            <money-in-cn
              v-if="!isDollar"
              :money="row.totalPrice"
              :ellipsis="false"
            />
          </div>
          <div v-if="row.targetTotalPrice">
            目标总价:
            {{
              row.targetTotalPrice ? strToThousands(row.targetTotalPrice) : '-'
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        label="供应商名称"
        width="140"
      >
        <template slot-scope="{ row }">
          <span>{{ row.supplierName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="requireTax"
        align="right"
        header-align="center"
        show-overflow-tooltip
        :label="`不含税单价(${isDollar ? '美元' : '元'})`"
        width="120"
      >
        <template v-slot="{ row }">
          <span>
            {{
              row.bargainPrice || row.noRateOfferPrice
                ? strToThousands(
                  row.isBargain ? row.bargainPrice : row.noRateOfferPrice
                )
                : '-'
            }}
          </span>
          <span v-if="row.isBargain" class="m-l-4 text-warning">
            议价
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        align="right"
        header-align="center"
        show-overflow-tooltip
        :label="`${'不含税单价'}(${isDollar ? '美元' : '元'})`"
        width="120"
      >
        <template v-slot="{ row }">
          <span>
            {{
              row.bargainPrice || row.offerPrice
                ? strToThousands(
                  row.isBargain ? row.bargainPrice : row.offerPrice
                )
                : '-'
            }}
          </span>
          <span v-if="row.isBargain" class="m-l-4 text-warning">
            议价
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="requireTax"
        key="requireTax"
        align="right"
        header-align="center"
        show-overflow-tooltip
        label="税率%"
      >
        <template v-slot="{ row }">
          <span>
            {{ row.offerTaxRate ? strToThousands(row.offerTaxRate) : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        key="num"
        align="right"
        header-align="center"
        label="授标数量"
        prop="num"
      >
        <template v-slot="{ row }">
          <span>
            {{ row.num ? strToThousands(row.num) : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="requireTax"
        align="right"
        header-align="center"
        :label="`不含税总价(${isDollar ? '美元' : '元'})`"
        width="120"
      >
        <template v-slot="{ row }">
          <span>
            {{ row.isBargain ? row.bargainTotalPrice : row.noRateBidAmount }}
            <span v-if="row.isBargain" class="m-l-4 text-warning">
              议价
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isWuling"
        align="right"
        header-align="center"
        :label="
          `${requireTax ? '含税总价' : '不含税总价'}(${
            isDollar ? '美元' : '元'
          })`
        "
        width="120"
      >
        <template v-slot="{ row }">
          <span>
            {{ row.isBargain ? row.rateBargainTotalPrice : row.bidAmount }}
            <span v-if="row.isBargain" class="m-l-4 text-warning">
              议价
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="交货地点">
        <template v-slot="{ row }">
          <span>{{ row.deliveryAddress || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="isShowTotal" class="m-t-20 m-b-20 text-bold">
      <div>
        全部品目预算汇总金额：{{ budgetTotalAmt }}
        {{ isDollar ? '美元' : '元' }}
      </div>
      <div class="m-t-6">
        全部品目报价汇总金额：{{ winnerTotalAmt }}
        {{ isDollar ? '美元' : '元' }}
      </div>
    </div>
  </div>
</template>

<script>
import MoneyInCn from '@/components/common/MoneyInCn'
import TableHeaderSetting from '@/components/common/TableHeaderSetting'

import { strToThousands } from '@/utils/utils'
import { round, uniqBy } from 'lodash'

import { getHeaderSettingApi } from '@/api/project-view'

export default {
  name: 'AwardSheet',

  components: {
    MoneyInCn,
    TableHeaderSetting
  },

  props: {
    // 是否是五菱发布的项目
    isWuling: {
      type: Boolean,
      default: false
    },

    tableData: {
      type: Array,
      default: () => []
    },

    // 跨越行数对象，key为品目id，value为当前品目需要跨越的行数
    spanNumObj: {
      type: Object,
      default: () => {}
    },

    // 是否含税
    requireTax: {
      type: Boolean,
      default: true
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    },

    /**
     * 是否展示汇总金额
     */
    isShowTotal: {
      type: Boolean,
      default: false
    },

    /**
     * 全部品目预算汇总金额
     */
    budgetTotalAmt: {
      type: [Number, String],
      default: ''
    },

    /**
     * 全部品目报价汇总金额
     */
    winnerTotalAmt: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      headerInfo: '',

      tableKey: '0'
    }
  },

  computed: {
    indexNum() {
      return (row, index) => {
        return this.spanNumObj[row.materielId].index || 1
      }
    },

    listOption() {
      const totalOptions = [
        {
          label: '品目名称',
          prop: 'materielName',
          fixed: true
        },
        {
          label: '品目编码',
          prop: 'materielCode'
        },
        {
          label: '数量',
          prop: 'materielNum'
        },
        {
          label: '参数型号',
          prop: 'materielModel'
        },
        {
          label: '品牌/制造商',
          prop: 'materielBrand'
        },
        {
          label: '交货地点',
          prop: 'deliveryAddress'
        },
        {
          label: '交货时间(天)',
          prop: 'deliveryDay'
        },
        {
          label: `预算单价(${this.isDollar ? '美元' : '元'})`,
          prop: 'budgetUnitPrice'
        },
        {
          label: `预算总价(${this.isDollar ? '美元' : '元'})`,
          prop: 'totalPrice'
        }
      ]
      return totalOptions.map(el => {
        if (this.headerInfo.includes(el.prop) || el.prop === 'materielName') {
          el.isShow = true
        } else {
          el.isShow = false
        }
        el.hide = !el.isShow
        return el
      })
    },

    listOptionObj() {
      const obj = {}
      this.listOption.forEach(el => {
        obj[el.prop] = el
      })
      return obj
    },

    /**
     * 品目预算汇总
     */
    itemBudgetTotal() {
      const tempList = uniqBy(this.tableData || [], 'materielId')

      return round(
        tempList.reduce((prev, cur) => {
          return prev + Number(cur.totalPrice || 0) * 100
        }, 0) / 100,
        2
      ).toFixed(2)
    },

    /**
     * 品目报价汇总
     */
    itemOfferTotal() {
      const tempList = this.tableData || []
      return round(
        tempList.reduce((prev, cur) => {
          const offerPrice = this.requireTax
            ? cur.noRateOfferPrice
            : cur.offerPrice
          return (
            prev + Number(offerPrice || 0) * 100 * (Number(cur.num || 0) * 100)
          )
        }, 0) / 10000,
        2
      ).toFixed(2)
    }
  },

  created() {
    this.getHeader()
  },

  methods: {
    strToThousands,

    /**
     * 是否展示某一列
     */
    showTableColumn(id) {
      return this.listOptionObj[id]?.isShow
    },

    /**
     * 获取表头设置
     */
    async getHeader() {
      try {
        const { data } = await getHeaderSettingApi(10)
        this.headerInfo = data.headerList || ''
        this.tableKey = '1'
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const tempObj = this.spanNumObj[row.materielId]
      const showHeaderInfo = this.listOption.filter(el => el.isShow) || []
      const spanNum = tempObj.num || 1
      const tempIndexArray = [...Array(showHeaderInfo.length + 2).keys()]
      if (tempIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex === tempObj.start) {
          return {
            rowspan: spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    headerDragend() {
      this.$refs.table.doLayout()
    },

    /**
     * 含税成交总价
     */
    resultTotalPrice(row) {
      // console.log('row', row)
      return row.bidAmount
      // let offerPrice = ''
      // if (this.requireTax) {
      //   // 如果报价含税，则供应商报价为noRateOfferPrice
      //   offerPrice = row.noRateOfferPrice
      //   const num = Number(row.num || 0) * 100
      //   const price = Number(offerPrice || 0) * 100
      //   const rate = 100 + Number(row.offerTaxRate || 0)
      //   const result = (num * price * rate) / 1000000
      //   return isNaN(result) ? '' : round(result, 2).toFixed(2)
      // } else {
      //   // 如果报价不含税，则供应商报价为offerPrice
      //   offerPrice = row.offerPrice
      //   const num = Number(row.num || 0) * 100
      //   const price = Number(offerPrice || 0) * 100
      //   const result = (num * price) / 10000
      //   return isNaN(result) ? '' : round(result, 2).toFixed(2)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-item {
  .column {
    margin-right: pixel-to-rem($n: 20);

    &:first-child {
      flex: 2;
    }

    &:last-child {
      flex: 1;
      margin-right: 0;
    }

    .column-item {
      display: flex;
      align-items: flex-start;

      .column-item__title {
        @include text-bold;
        white-space: nowrap;
        flex: 1;
        text-align: right;

        &::after {
          content: '：';
          display: inline-block;
        }
      }

      .column-item__content {
        flex: 1;
        margin: 0;
        text-align: left;
      }
    }
  }
}
</style>
